import { Component, OnInit, ViewChild, Input, ElementRef, isDevMode } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { addDays, addSeconds, addMinutes, addHours, endOfDay, startOfMonth, endOfMonth, isSameDay, isSameMonth, startOfDay, subDays } from 'date-fns';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscModalComponent } from '../usc-modal/usc-modal.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { UscUserLookupComponent } from '../usc-user-lookup/usc-user-lookup.component';
import { createUrlResolverWithoutPackagePrefix } from '@angular/compiler';
import { UscEmailComposerComponent } from '../usc-email-composer/usc-email-composer.component';
import { UscAttachmentLookupComponent } from '../usc-attachment-lookup/usc-attachment-lookup.component';
import { SessionService } from '../../../services/session.service';
import { AuthService } from '../../../services';
import { User } from '../../../models';
import { UscTimeslotPickerComponent } from '../usc-timeslot-picker/usc-timeslot-picker.component';
import { SliderComponent } from '../../common/slider/slider.component';

@Component({
    selector: 'usc-impression',
    template: ``
  })
export class UscImpressionComponent implements OnInit {
  @Input() itemID: number = 0;
  @ViewChild('line_count') line_count_slider: SliderComponent;
  @ViewChild('in_contract') in_contract_slider: SliderComponent;
  @ViewChild('out_of_contract') out_of_contract_slider: SliderComponent;
  @ViewChild('handset_count') handset_count_slider: SliderComponent;
  @ViewChild('iot_count') iot_count_slider: SliderComponent;
  @ViewChild('cd_count') cd_count_slider: SliderComponent;

  public activeUser:User;
  //#region properties && states
  public loading:boolean = true;
  public is_advanced_filter_shown:boolean = false;
  // user access
  public isAdmin:boolean = false;
  public isLeader:boolean = false;
  public isStore:boolean = false;
  public allowReassign:boolean = false;
  public allowAutoReassign:boolean = false;
  public allowSmsStatusFilter: boolean = false;
  // client access for assoicate
  public isUSCellRetail:boolean = false;
  public isUSCellCorp:boolean = false;
  public isUSCellAgent:boolean = false;
  public isUSCellInsideSales:boolean = false;
  public isUSCellTelesales:boolean = false;
  public isChurnAlertsEnabled:boolean = true;
  // views
  public view:string = "";
  // actions
  public action_no_answer:string = this.uscStoreService.action_no_answer;
  public action_no_show_archive:string = this.uscStoreService.action_no_show_archive;
  public action_move_to_first:string = this.uscStoreService.action_move_to_first;
  public action_mass_archive:string = this.uscStoreService.action_mass_archive;
  public action_mass_reassign:string = this.uscStoreService.action_mass_reassign;
  public action_auto_reassign:string = this.uscStoreService.action_auto_reassign;
  public view_update_info:string = this.uscStoreService.form_update_info;
  public view_purchase:string = this.uscStoreService.form_purchase;
  public view_future_sales:string = this.uscStoreService.form_future_sale;
  public view_file_upload:string = this.uscStoreService.form_file_upload;  
  // transition
  public transition_no_show:string = "transition_no_show";
  public transition_compose_email:string = "transition_compose_email";
  public transition_mass_reassign:string = "transition_mass_reassign";
  public transition_new_referral:string = "transition_new_referral";
  public transition_optin_request:string = "transition_optin_request";
  public transition_associate_required:string = "transition_associate_required";
  // server event 
  public event_save_call_back:string = "save_call_back";
  // view item and table items
  public items:Array<any> = [];  
  // paging 
  public curPage:number = 1;
  public pageSize:number = 15;
  public pageCount:number = 0;
  public itemCount:number = 0;
  // sorting
  public FIRST_LAST:string = "FL";
  public LAST_FIRST:string = "LF";
  public nameFormat:string = this.LAST_FIRST;
  public orderBy:string = "dl_name";
  public asc:boolean = true;
  public sortable_header_classes:any = {
    co_lastname: "sn_header sn_sortable",
    co_firstname: "sn_header sn_sortable",
    co_work_phone1: "sn_header sn_sortable",
    cm_name: "sn_header sn_sortable",
    cfd_cn: "sn_header sn_sortable",
    cfd_cdr: "sn_header sn_sortable",
    cfd_vdr: "sn_header sn_sortable",
    cfd_cp1: "sn_header sn_sortable",
    cfd_pri: "",
    sql_sms_activity: "sn_header sn_sortable",
    ca_date: "sn_header sn_sortable",
    cfd_ct:  "sn_header sn_sortable",
    dl_converted_date: "sn_header sn_sortable",
    me_date: "sn_header sn_sortable",
    cfd_industry: "sn_header sn_sortable",
    cfd_plan_type: "sn_header sn_sortable",
    cfd_iad: "sn_header sn_sortable",
  }
  // month names
  public month_names = [ "(JAN)",  "(FEB)",  "(MAR)",  "(APR)",  "(MAY)",  "(JUN)",  "(JUL)",  "(AUG)",  "(SEP)",  "(OCT)",  "(NOV)",  "(DEC)" ];
  // item selection
  public selectedItemIDs:any = { };
  public selectedItemIDCount:number = 0;
  public pageItemsChecked:boolean = false;
  public view_as_user_list: any[] = [];
  // data filter tracker
  public data_filter_tracker: any = { }
  // data filters
  public data_filter:any = {
    u_user_ID: [],
    cm_name: [],
    dl_account_type: [],
    sql_status: [],
    sql_lasting_status: [],
    sql_sms_activity: [],
    u_team_ID: [],
    sql_line_count: [],
    sql_in_contract: [],
    sql_out_of_contract: [],
    sql_handset_count: [],
    sql_iot_count: [],
    sql_cd_count: [],
  }
  public current_filter:any = {
    owner: { label: "All", value: "" },
    team: { label: "All", value: "" },
    campaign: { label: "All Campaigns", value: "" },
    sql_line_count: { label: "", value: "" },
    sql_in_contract: { label: "", value: "" },
    sql_out_of_contract: { label: "", value: "" },
    sql_handset_count: { label: "", value: "" },
    sql_iot_count: { label: "", value: "" },
    sql_cd_count: { label: "", value: "" },
    industry: { label: "All", value: "" },
    plan_type: { label: "All", value: "" },
    potential_sales: { label: "All Forecasted Sales", value: "" },
    customer_type: { label: "All Customer Types", value: "" },
    status: { label: "All Statuses", value: "" },
    lasting_status: { label: "All Statuses", value: "" },
    sms_activity: { label: "All SMS Activities", value: "" },
    pd_interest: { label: "All Product Interest", value: "" },
    mf_interest: { label: "All Manufacturer Interest", value: "" },
    follow_up_calls: { label: "All Calls", value: "" },
    converted_date: { label: "All Creation Dates", value: "" },
    initial_activation_date: { label: "All Initial Activation Dates", value: "" },
    impression: { label: "", value: "" },
    associate: { label: "All", value: "" },
  }
  // converted date range
  public converted_date_from:string;
  public converted_date_to:string;
  // initial_activation_date range
  public initial_activation_date_from:string;
  public initial_activation_date_to:string;
  //#endregion
  // default range slider options     
  public default_slider_options:any = { id: '', width: 200, height: 15, min: 0, max: 10, min_range: 1, step: 1, is_numeric: true, is_percentage: false, value_at_min_max_as_all: true };
  public slider_options:any = { sql_line_count: null, sql_in_contract: null, sql_out_of_contract: null, sql_handset_count: null, sql_iot_count: null, sql_cd_count: null };
  slider_filters: string[] = [ "sql_line_count", "sql_in_contract", "sql_out_of_contract", "sql_handset_count", "sql_iot_count", "sql_cd_count" ];
  slider_filters_ready: boolean = false;
  public onSliderValueChangeBindling: Function;     // call back for sn-field on processing list items 
  public silder_range_increment: number = 5;
  public view_as_current_user: string = "None";
  public view_as_current_user_ID: number = 0;
//   public isQueuingModuleAccessEnabled: boolean = false;

  constructor(
    public uscStoreService: UscStoreService,
    public ngbModal: NgbModal,
    public ngbActiveModal: NgbActiveModal,
    public sessionService: SessionService,
    public authService: AuthService
  ) { 
    var today = new Date();
    var year = today.getFullYear();
    var month:any = today.getMonth() + 1;
    if (month < 10) month = '0' + month.toString();
    var day:any = today.getDate();
    if (day < 10) day = '0' + day.toString();
    this.converted_date_from = `${year}-${month}-01`;
    this.converted_date_to = `${year}-${month}-${day}`;
    this.initial_activation_date_from = `${year}-${month}-01`;
    this.initial_activation_date_to = `${year}-${month}-${day}`;
  }

  isFirstImpression() { return this.view == this.uscStoreService.view_first; }
  isMiddleImpression() { return this.view == this.uscStoreService.view_middle; }
  isLastingImpression() { return this.view == this.uscStoreService.view_lasting; }
  IsViewAsUserEnabled() { return this.isFirstImpression() && this.uscStoreService.IsViewAsUserEnabled(); }
  
  public isDevMode;

  ngOnInit() {
    this.isDevMode = isDevMode();

    switch (this.view) {
      case this.uscStoreService.view_first: this.current_filter.impression.value = "First Impression"; break;
      case this.uscStoreService.view_middle: this.current_filter.impression.value = "Middle Impression"; break;
      case this.uscStoreService.view_lasting: this.current_filter.impression.value = "Lasting Impression"; break;
    }
    // this.isQueuingModuleAccessEnabled = this.uscStoreService.isQueuingModuleAccessEnabled();
    this.slider_filters_ready = false;
    this.onSliderValueChangeBindling = this.onSliderValueChange.bind(this);
    this.activeUser = this.authService.getActive();
    this.isAdmin = this.uscStoreService.isAdmin();
    this.isLeader = this.uscStoreService.isLeader();
    this.isStore = this.uscStoreService.isStore();
    this.current_filter.campaign = this.uscStoreService.getDefaultCampaignFilter();
    if (this.isLeader && this.uscStoreService.getItemCustomFieldValue(this.activeUser, "User Search Scope") == "Self") {
      var filter = this.uscStoreService.getDefaultSearchScope('u_user_ID');
      if (filter != null) this.current_filter.owner = filter;
    } 
    this.isUSCellRetail = this.uscStoreService.isUSCellRetail();
    this.isUSCellCorp = this.uscStoreService.isUSCellCorp();
    this.isUSCellAgent = this.uscStoreService.isUSCellAgent();
    this.isUSCellInsideSales = this.uscStoreService.isUSCellInsideSales();
    this.isUSCellTelesales = this.uscStoreService.isUSCellTelesales();
    this.allowSmsStatusFilter = this.isCustomerTextMessagingEnabled();
    this.isChurnAlertsEnabled = this.uscStoreService.is2022Q4Phase4Enabled();
    this.allowReassign = false;
    if (this.isLeader) this.allowReassign = (this.isUSCellAgent || this.isUSCellCorp || this.isUSCellTelesales);
    if (this.isStore) this.allowAutoReassign = (this.isUSCellAgent || this.isUSCellCorp || this.isUSCellTelesales);

    for (const p in this.slider_options) {
      this.slider_options[p] = JSON.parse(JSON.stringify(this.default_slider_options));
      this.slider_options[p].ready = false;
    }

    this.loadItems();

    this.uscStoreService.updatedViewItems.subscribe(updatedItems => {
      var archivedItems = [];
      this.items.forEach(c => {
        var updatedItem = updatedItems.find(i => i.dl_ID == c.dl_ID);
        if (updatedItem) {
          if (updatedItem.oi_status != c.oi_status) {
            c.oi_status = updatedItem.oi_status;
          } 

          if (updatedItem.cfd_esi != c.cfd_esi || updatedItem.cfd_css != c.cfd_css) {
            c.cfd_esi = updatedItem.cfd_esi;
            c.cfd_css = updatedItem.cfd_css;
          }

          if (updatedItem.cfd_hum != c.cfd_hum) {
            c.cfd_hum = updatedItem.cfd_hum;
          }
          c.cfd_hcb = updatedItem.cfd_hcb;
          c.cfd_hna = updatedItem.cfd_hna;
          c.cfd_hpn = updatedItem.cfd_hpn;
          if (c.dl_stage == "Archive") archivedItems.push(updatedItem);
        }
      })
      archivedItems.forEach(i => {
        this.items.splice(this.items.indexOf(i), 1);
      })
    });
  }

  getExecuteScriptType(bSearchData:boolean = true, bTotalCount:boolean = true) {
    if (bSearchData && bTotalCount) return "ST_All";
    if (bSearchData) return "ST_Search";
    if (bTotalCount) return "ST_TotalCount";
  }

  // gather all search params in json format to be used as request string parameter
  getSearchParams(executeScriptType:string = null) {
    var params:any = { }
    params.id = this.itemID;
    params.p = this.curPage;
    params.ps = this.pageSize;
    params.ob = this.orderBy;
    if (executeScriptType) params.est = executeScriptType;
    if (this.view == this.uscStoreService.view_first && this.view_as_current_user_ID > 0) {
        params["SP_VIEW_AS_USER_ID"] = this.view_as_current_user_ID;
    }
    params.obd = this.asc ? "asc" : "desc";
    var filter = [
      // instant filters (do these first)
      { field: "sql_sms_activity",    op: "", value: this.current_filter.sms_activity.value.length > 0 ? this.current_filter.sms_activity.value : null  },  // op defined in view config
      { field: "sql_fuc",             op: "", value: this.current_filter.follow_up_calls.value.length > 0 ? this.current_filter.follow_up_calls.value : null  },
      { field: "sql_ps",              op: ">", value: this.current_filter.potential_sales.value.length > 0 ? this.current_filter.potential_sales.value : null  },
      { field: "sql_cd",              op: "", value: this.current_filter.converted_date.value.length > 0 ? this.current_filter.converted_date.value : null  },
      { field: "sql_ct",              op: "", value: this.current_filter.customer_type.value.length > 0 ? this.current_filter.customer_type.value : null  },  // op defined in view config
      { field: "sql_iad",              op: "", value: this.current_filter.initial_activation_date.value.length > 0 ? this.current_filter.initial_activation_date.value : null  },
      // fast filters (do these second)
      { field: "sql_pd_interest",     op: "", value: this.current_filter.pd_interest.value.length > 0 ? this.current_filter.pd_interest.value : null  },  // op defined in view config
      { field: "sql_mf_interest",     op: "", value: this.current_filter.mf_interest.value.length > 0 ? this.current_filter.mf_interest.value : null  },  // op defined in view config
      // search required (do these last)
      { field: "cm_name",             op: "=", value: this.current_filter.campaign.value.length > 0 ? this.current_filter.campaign.value : null  },
      { field: "sql_line_count",      op: "", value: this.current_filter.sql_line_count.value.length > 0 ? this.current_filter.sql_line_count.value : null  },
      { field: "sql_in_contract",     op: "", value: this.current_filter.sql_in_contract.value.length > 0 ? this.current_filter.sql_in_contract.value : null  },
      { field: "sql_out_of_contract", op: "", value: this.current_filter.sql_out_of_contract.value.length > 0 ? this.current_filter.sql_out_of_contract.value : null  },
      { field: "sql_handset_count",   op: "", value: this.current_filter.sql_handset_count.value.length > 0 ? this.current_filter.sql_handset_count.value : null  },
      { field: "sql_iot_count",       op: "", value: this.current_filter.sql_iot_count.value.length > 0 ? this.current_filter.sql_iot_count.value : null  },
      { field: "sql_cd_count",        op: "", value: this.current_filter.sql_cd_count.value.length > 0 ? this.current_filter.sql_cd_count.value : null  },
      { field: "cfd_industry",        op: "=", value: this.current_filter.industry.value.length > 0 ? this.current_filter.industry.value : null  },
      { field: "cfd_plan_type",       op: "=", value: this.current_filter.plan_type.value.length > 0 ? this.current_filter.plan_type.value : null  },
      { field: "dl_account_type",     op: "=", value: this.current_filter.associate.value.length > 0 ? this.current_filter.associate.value : null  },
      { field: "dl_type",             op: "=", value: this.current_filter.impression.value.length > 0 ? this.current_filter.impression.value : null  },
      { field: "sql_status",          op: "", value: this.current_filter.status.value.length > 0 ? this.current_filter.status.value : null  } , // op defined in view config
      { field: "sql_lasting_status",  op: "", value: this.current_filter.lasting_status.value.length > 0 ? this.current_filter.lasting_status.value : null  },  // op defined in view config
      { field: "u_user_ID",           op: "=", value: this.current_filter.owner.value.length > 0 ? this.current_filter.owner.value : null },
      { field: "u_team_ID",           op: "=", value: this.current_filter.team.value.length > 0 ? this.current_filter.team.value : null  },
  ];  
    params.f = JSON.stringify(filter);
    return params;
  }

  loadItems() {
    this.itemCount = 0;
    this.pageCount = 0;
    this.pageItemsChecked = false;
    var activeUser = this.authService.getActive();
    var features = this.uscStoreService.getItemCustomFieldValue(activeUser, "Disabled Features");
    this.uscStoreService.getViewAsUserList().subscribe(result => {
        var view_as_user_list = [{area:"",store:"",firstname:"",lastname:"None",user_ID:0,title:""}]
        if (result != null) view_as_user_list = view_as_user_list.concat(result);
        this.view_as_user_list = view_as_user_list;
    })
    //console.log(features);
    //if (features == undefined || features == null || features.indexOf("Data Filter") < 0) this.loadMetaData();
    if (features == undefined || features == null || features.indexOf("Data Filter") < 0) {
        var prev_data_filter_tracker = this.data_filter_tracker;
        // reset filter tracker to allow on-demand loading
        this.data_filter_tracker = { };  
        // transfer numeric slider filters since they do not need to be reset
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_line_count) this.data_filter_tracker.sql_line_count = prev_data_filter_tracker.sql_line_count;
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_in_contract) this.data_filter_tracker.sql_in_contract = prev_data_filter_tracker.sql_in_contract;
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_out_of_contract) this.data_filter_tracker.sql_out_of_contract = prev_data_filter_tracker.sql_out_of_contract;
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_handset_count) this.data_filter_tracker.sql_handset_count = prev_data_filter_tracker.sql_handset_count;
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_iot_count) this.data_filter_tracker.sql_iot_count = prev_data_filter_tracker.sql_iot_count;
        if (prev_data_filter_tracker && prev_data_filter_tracker.sql_cd_count) this.data_filter_tracker.sql_cd_count = prev_data_filter_tracker.sql_cd_count;
    } 
    this.reloadItems();
  }

  // load metadata for the current view, should only need to load on initialization
  loadMetaData(filter_name:string = null) {
    var params = this.getSearchParams();
    var filters = JSON.parse(params.f);

    var filter_index = filters.findIndex(f => f.field == filter_name);
    this.loadFilterMetaDeta(filters, filter_index, false);

    // setTimeout(() => {
    //     this.loadFilterMetaDeta(filters, 0);
    // }, 100);
  }

  updateSliderFilters(data_filter) {
    var slider_filter_name = this.slider_filters.find(f => data_filter[f] != null);
    if (slider_filter_name) {
      var slider_option = this.slider_options[slider_filter_name];
      slider_option.id = slider_filter_name;
     
      var min_filter_data = data_filter[slider_filter_name].find(f => f.label == 'min');
      var max_filter_data = data_filter[slider_filter_name].find(f => f.label == 'max');
      
      slider_option.min = min_filter_data != null ? parseInt(min_filter_data.value) : 0;
      slider_option.max = max_filter_data != null ? parseInt(max_filter_data.value) : 10;
      // determine the slider selected min_value/max_value
      // update the current slider min_value/max_value if there is no active slider filter value set
      if (this.current_filter[slider_filter_name].value == "") {
        slider_option.min_value = slider_option.min;
        slider_option.max_value = slider_option.max;
      } else {
        // if there is active filter value, restore if logical
        slider_option.min_value = this.current_filter[slider_filter_name].min_value;
        slider_option.max_value = this.current_filter[slider_filter_name].max_value;
      }
    
      // only on first page load, set slider_filters_ready = true when all slider have been initialized
      slider_option.ready = true;
      var slider_filters_ready = true;
      this.slider_filters.forEach(f => {
        slider_filters_ready = slider_filters_ready && this.slider_options[f].ready;
      })
      this.slider_filters_ready = slider_filters_ready;
      
      if (this.slider_filters_ready) {
        if (this.line_count_slider) this.line_count_slider.initialize();
        if (this.in_contract_slider) this.in_contract_slider.initialize();
        if (this.out_of_contract_slider) this.out_of_contract_slider.initialize();
        if (this.handset_count_slider) this.handset_count_slider.initialize();
        if (this.iot_count_slider) this.iot_count_slider.initialize();
        if (this.cd_count_slider) this.cd_count_slider.initialize();
      }
    }
  }

  getAdvancedFilterStyle() {
    var style:any = { };
    if (!this.is_advanced_filter_shown) style.display = "none";
    return style;
  }

  onSliderValueChange(options, min_value, max_value) {
    console.log(options, min_value, max_value);
    var custom_range_filter = this.data_filter[options.id].find(f => f.label == 'Custom Range');
    // make a copy of the filter object to avoid value change to the original
    if (options.min == min_value && options.max == max_value) {
      custom_range_filter = { label: "", value: "" };
    } else {
      custom_range_filter = JSON.parse(JSON.stringify(custom_range_filter));
      custom_range_filter.value = custom_range_filter.value.replace('_FROM_', min_value.toString()).replace('_TO_', max_value.toString());
      custom_range_filter.min_value = min_value;
      custom_range_filter.max_value = max_value;
    }
    this.current_filter[options.id] = custom_range_filter;
    this.curPage = 1;
    this.loadItems();
  }

  loadFilterMetaDeta(filters, index, load_all_filters:boolean = true) {
    var params = this.getSearchParams();
    var f = filters[index];
    console.log(f);
    params.return_filter = f.field;
    this.uscStoreService.getMetaData(this.view, params, true).subscribe(result => {
      if (result.meta_data.data_filter.sql_status) {
        for (var i = 0; i < result.meta_data.data_filter.sql_status.length; i++) {
          if (result.meta_data.data_filter.sql_status[i].label == '1st Attempt') {
            result.meta_data.data_filter.sql_status[i].label = 'Not Called';
          }
        }
      }

      // slider filters is handled differently compare to list filters.  the filter data set does not reset when reloading the item list.
      // this allows the slider to always keep the user selection without re-initializing
      if (!this.slider_filters_ready) this.updateSliderFilters(result.meta_data.data_filter);

      var is_not_slider_filter = this.slider_filters.find(f => result.meta_data.data_filter[f] == null);
      // store a copy of all filter data.  for the slider filters, only the initial data set is store and will not get updated later
      if (!this.slider_filters_ready || is_not_slider_filter) {
        this.data_filter[f.field] = result.meta_data.data_filter[f.field];
        this.data_filter_tracker[f.field] = 'loaded';
      }
      this.sessionService.log(f.field, this.data_filter[f.field]);
      if (index + 1 < filters.length && load_all_filters) {
        setTimeout(() => {
          this.loadFilterMetaDeta(filters, index + 1);
        }, 1 * 100);
      }
    },
    err => { console.log(err) }
  );

  }

  reloadItems() {
    let dlg = this.showCustomPromptDlg({ }, { msg: "Loading Leads" });
    this.updateHeader();
    if (this.view) {
      // search for data (partial)
      var params = this.getSearchParams(this.getExecuteScriptType(true, false));
      this.uscStoreService.getData(this.view, params).subscribe(
        result => {
          this.uscStoreService.setCurrentViewItems(result.items);
          this.items = result.items;
          // reset id field as it should only be set as an input param
          this.itemID = 0;
          this.loading = false;
          dlg.dismiss();

            // get total count of data
            var params = this.getSearchParams(this.getExecuteScriptType(false, true));
            this.uscStoreService.getData(this.view, params).subscribe(
                result => {
                    this.itemCount = result.total_count;
                    this.pageCount =  Math.ceil(this.itemCount / this.pageSize);
                },
                err => {
                    console.log(err);
                }
            );
        },
        err => {
          console.log(err);
        }
      );

    //   // get total count of data
    //   var params = this.getSearchParams(this.getExecuteScriptType(false, true));
    //   this.uscStoreService.getData(this.view, params).subscribe(
    //     result => {
    //       this.itemCount = result.total_count;
    //       this.pageCount =  Math.ceil(this.itemCount / this.pageSize);
    //     },
    //     err => {
    //       console.log(err);
    //     }
    //   );
    }
  }

  //#region page view user event 
  //#region paging
  onPageChange(event) {
    var newPage = event.target.value;
    if (newPage > this.pageCount) newPage = this.pageCount;
    if (newPage < 1) newPage = 1;
    if (this.curPage != newPage) {
      this.curPage = newPage;
      this.reloadItems();
    } else {
      event.target.value = this.curPage;
    }
  }

  prevPage() {
    if (this.curPage > 1) {
      this.curPage--;
      this.reloadItems();
      this.pageItemsChecked = false;
    }
  }

  nextPage() {
    if (this.curPage < this.pageCount) {
      this.curPage++;
      this.reloadItems();
      this.pageItemsChecked = false;
    }
  }
  //#endregion paging

  selectAllItems(event) {
    var startIndex = (this.curPage - 1) * this.pageSize;
    for (var i = 0; startIndex + i < this.itemCount && i < this.pageSize; i++) {
      this.selectItem(event, this.items[i]);
    }
    this.pageItemsChecked = true;
  }

  selectItem(event, item) {
    if (this.selectedItemIDs[item.view_ID] == undefined || this.selectedItemIDs[item.view_ID] != event.target.checked) {
      this.selectedItemIDCount += event.target.checked ? 1 : -1;
      this.selectedItemIDs[item.view_ID] = event.target.checked;
    }
  }

  clearAllSelectedItems() {
    this.pageItemsChecked = false;
    this.selectedItemIDCount = 0;
    for (var p in this.selectedItemIDs) {
      this.selectedItemIDs[p] = false;
    }
  }

  sort(orderBy:string, e) {
    if (orderBy != this.orderBy) {
      this.asc = true;
    } else {
      this.asc = !this.asc;
    }
    this.orderBy = orderBy;
    this.reloadItems();
  }

  updateHeader() {
    for (var p in this.sortable_header_classes) {
      this.sortable_header_classes[p] = "sn_header sn_sortable";                // unhighlight previous sorted column
      if (p == this.orderBy) {
        this.sortable_header_classes[p] = "sn_header sn_sortable active";       // highlight previous sorted column
      }
    }
    if (this.orderBy == 'co_firstname') this.nameFormat = this.FIRST_LAST;
    if (this.orderBy == 'co_lastname') this.nameFormat = this.LAST_FIRST;
    if (this.orderBy == "cfd_pri") this.asc = true;
  }
  
  loadFilter(filter) {
    if (this.data_filter_tracker && this.data_filter_tracker[filter] != 'loaded' && this.data_filter_tracker[filter] != 'loading') {
        console.log("loading filter: " + filter);
        this.data_filter_tracker[filter] = 'loading';
        this.loadMetaData(filter);
    } 
  }

  filter(column, filter) {
    switch (column) {
      case 'u_user_ID': this.current_filter.owner = filter || { label: "All", value: "" }; break;
      case 'u_team_ID': this.current_filter.team = filter || { label: "All", value: "" }; break;
      case 'cm_name': this.current_filter.campaign = filter || { label: "All Campaigns", value: "" }; break;
      case 'sql_ps': this.current_filter.potential_sales = filter || { label: "All Forecasted Sales", value: "" }; break;
      case 'dl_account_type': this.current_filter.associate = filter || { label: "All", value: "" }; break;
      case 'sql_ct': this.current_filter.customer_type = filter || { label: "All Customer Types", value: "" }; break;
      case 'sql_status': this.current_filter.status = filter || { label: "All Statuses", value: "" }; break;
      case 'sql_lasting_status': this.current_filter.lasting_status = filter || { label: "All Statuses", value: "" }; break;
      case 'sql_sms_activity': this.current_filter.sms_activity = filter || { label: "All SMS Activities", value: "" }; break;
      case 'sql_pd_interest': this.current_filter.pd_interest = filter || { label: "All Product Interest", value: "" }; break;
      case 'sql_mf_interest': this.current_filter.mf_interest = filter || { label: "All Manufacturer Interest", value: "" }; break;
      case 'sql_fuc': this.current_filter.follow_up_calls = filter || { label: "All Calls", value: "" }; break;
      case 'industry': this.current_filter.industry = filter || { label: "All", value: "" }; break;
      case 'plan_type': this.current_filter.plan_type = filter || { label: "All", value: "" }; break;
      case 'sql_cd': 
        // make a copy of the filter object to avoid value change to the original
        var temp_filter = JSON.parse(JSON.stringify(filter));
        if (filter.label == "Custom Date Range") {
          var cd_cdr = this.data_filter.sql_cd.find(f => f.label == "Custom Date Range");
          temp_filter.value = cd_cdr.value.replace('_FROM_', this.converted_date_from).replace('_TO_', this.converted_date_to);
        }
        if (column == "sql_cd") this.current_filter.converted_date = temp_filter || { label: "All Creation Dates", value: "" }; 
        break;
      case 'sql_iad': 
        // make a copy of the filter object to avoid value change to the original
        var temp_filter = JSON.parse(JSON.stringify(filter));
        if (filter.label == "Custom Date Range") {
          var iad_cdr = this.data_filter.sql_iad.find(f => f.label == "Custom Date Range");
          temp_filter.value = iad_cdr.value.replace('_FROM_', this.initial_activation_date_from).replace('_TO_', this.initial_activation_date_to);
        }
        if (column == "sql_iad") this.current_filter.initial_activation_date = temp_filter || { label: "All Creation Dates", value: "" }; 
        break;
    }
    this.curPage = 1;
    this.loadItems();
  }

  viewAsUser(u) {
    this.view_as_current_user = u.firstname + ' ' + u.lastname;
    this.view_as_current_user_ID = u.user_ID;
    this.curPage = 1;
    this.loadItems();
  }
  
  isSmsIntroductionEnabled(item): boolean {
    if (item.co_type.indexOf('Existing') >= 0 && item.cfd_esi == "Yes" && this.uscStoreService.isCustomerTextMessagingEnabled()) {
      if (!this.showAssociate() || item.dl_account_type) {
        return (item.cfd_css == null || item.cfd_css == '' || item.cfd_css == 'None');
      }
    }
    return false;
  }

  processOutcome(item, outcome) {
    // 2025-03-31: Call limit blocking feature
    let bFirstImpCallOutcomeBlocked:boolean = false;
    if (this.view == this.uscStoreService.view_first) {
        switch (outcome) {
            case this.uscStoreService.form_interested:
            case this.uscStoreService.form_not_interested:
            case this.uscStoreService.form_call_back:
            case this.uscStoreService.action_no_answer:
                bFirstImpCallOutcomeBlocked = this.uscStoreService.isCallTimeLimitExceeded(item, new Date());
                if (bFirstImpCallOutcomeBlocked) {
                    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                    modalRef.componentInstance.parentView = this.view;
                    modalRef.componentInstance.data = item;
                    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_call_outcome_limit_exceeded;
                    modalRef.result.then((result) => {
                        // do nothing
                    }, (reason) => {
                        console.log("what happened here?");
                    });                
                } else {
                    this.uscStoreService.recordCallOutComeAgainstCallLimit(item, outcome, new Date());
                }
                break;
        }
    }

    if (!bFirstImpCallOutcomeBlocked) {
        // enforce associate for agents
        // skip enforcement if it is retail or middle/lasting impression, or has valid associate (dl_account_type not empty)
        if (!this.showAssociate() || this.view != this.uscStoreService.view_first || item.dl_account_type) {
        var outcome_msg:Array<any> = [];
        switch (outcome) {
            case this.uscStoreService.action_no_answer:
            case this.uscStoreService.action_no_show_archive:
            case this.uscStoreService.action_move_to_first:
            case this.uscStoreService.action_move_to_lasting:
            var msg = "";
            if (outcome == this.uscStoreService.action_no_answer) msg = "Updating Lead";
            else if (outcome == this.uscStoreService.action_no_show_archive) msg = "Archiving Lead";
            else if (outcome == this.uscStoreService.action_move_to_first) msg = "Moving to First";
            else if (outcome == this.uscStoreService.action_move_to_lasting) msg = "Moving to Lasting";
            let dlg = this.showCustomPromptDlg(item, { msg: msg });
            this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, outcome, "").subscribe(
                result => { 
                dlg.close();
                this.pageItemsChecked = false;
                this.uscStoreService.setViewItemUpdated(item, true);
                // if sms intro enabled, prompt to send customer sms intro
                if (this.isSmsIntroductionEnabled(item) && outcome == this.uscStoreService.action_no_answer) {
                    item.cfd_lcod = (new Date()).toISOString();
                    this.showPromptDlg(item, this.transition_optin_request, outcome);
                } else {
                    this.reloadItems(); 
                }
                }
            );
            break;
            default:
            this.showOutcomeLog(item, outcome);
            break;
        }
        } else {
        this.showPromptDlg(item, this.transition_associate_required);
        }
    }
  }

  getSelectedItemIDsString() {
    let idList = [];
    for (var p in this.selectedItemIDs) {
      if (this.selectedItemIDs[p] === true) {
        idList.push(p);
      }
    }
    return idList.join();
  }

  formatContactNumber(phone:string) {
    var formatted = "";
    if (phone && phone.length == 10) {
      formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
    }
    return formatted;
  }

  getDateMonthName(dl_datetime_created:string) {
    let datetime_created = new Date(Date.parse(dl_datetime_created));
    datetime_created.setHours(datetime_created.getHours() - 8);
    return this.month_names[datetime_created.getMonth()];
  }

  onAction(action) {
    switch (action) {
      case this.action_mass_archive:
      case this.action_auto_reassign:
        var params = { idList: this.getSelectedItemIDsString() };
        var msg = action == this.action_mass_archive ? "Archiving Leads" : "Reassigning Leads";
        let dlg = this.showCustomPromptDlg({ }, { msg: msg });
        this.uscStoreService.processActionOnViewItems(this.view, action, params).subscribe(
          result => { 
            dlg.dismiss();
            this.clearAllSelectedItems();
            this.reloadItems(); 
          }
        );
        break;
      case this.transition_mass_reassign:
        this.openUserLookup();
        break;
    }
  }

  openUserLookup() {
    const modalRef = this.ngbModal.open(UscUserLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      console.log(result);
      let dlg = this.showCustomPromptDlg({ }, { msg: "Reassigning leads" });
      var params = { idList: this.getSelectedItemIDsString(), user_ID: result.selectedItem.ID };
      this.uscStoreService.processActionOnViewItems(this.view, this.action_mass_reassign, params).subscribe(
        result => { 
          dlg.dismiss();
          this.clearAllSelectedItems();
          this.reloadItems(); 
        }
      );
    }, (reason) => {
      console.log("User Lookup Closed");
    });
  }

  showOutcomeLog(item, outcome) {
    const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = outcome;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
    modalRef.result.then((result) => {
      var bContainEmail = false;
      if (this.isSmsIntroductionEnabled(item) && outcome == this.uscStoreService.form_interested) {
        this.uscStoreService.setTriggerChatItemReload();                          // trigger chat reload in case the deal sms status changed
      }
      for (var i = 0; i < result.data.length; i++) {
        if (result.data[i].key == "co_email") {
          bContainEmail = result.data[i].value != null && result.data[i].value.indexOf('@') > 0;
        }
      }

      var bPromptComposeEmail = false;
      var bPromptSmsCampaignIntro = false;
      var bCalendarApptCreated = false;
      var bPromptSameDayAlert = false;
      // var bPromptNotInterested = false;
      switch (outcome) {
        case this.uscStoreService.form_interested: 
        case this.uscStoreService.form_last_interested:
          // 2021-08-26: REQUESTED: remove email prompt for all 
          bPromptComposeEmail = false;
          if (this.isUSCellRetail) {
            var cfd_fumd = result.data.find(d => d.key == 'cfd_fumd');
            if (cfd_fumd) {
              bCalendarApptCreated = true;
              var date = new Date(cfd_fumd.value); // this will convert date value to localtime 
              var today = new Date();
              // compare UTC string to today instead due to javascript converts to localtime 
              if (date.getUTCFullYear() == today.getFullYear() && date.getUTCMonth() == today.getUTCMonth() && date.getUTCDate() == today.getDate()) {
                bPromptSameDayAlert = true;
              }
            }
          }
          break;
        case this.uscStoreService.form_call_back:
        case this.uscStoreService.form_lvm_no_answer:
          bPromptSmsCampaignIntro = (this.isSmsIntroductionEnabled(item));
          break;
        // case this.uscStoreService.form_not_interested:
        //   bPromptNotInterested = true;
        //   break;
      }
      if (bCalendarApptCreated) this.uscStoreService.reloadCalendarEvents(result.event);
      if (bPromptSameDayAlert) {
        this.openOkDialog('Please alert other Associates within your store that you have booked a same-day appointment.', true);
      } else if (bPromptSmsCampaignIntro) {
        item.cfd_lcod = (new Date()).toISOString();
        this.showPromptDlg(item, this.transition_optin_request, result.event);
      } else if (bContainEmail && bPromptComposeEmail) { 
        this.showPromptDlg(item, this.transition_compose_email, result.event);
      // } else if (bPromptNotInterested) {
      //   this.showPromptDlg(item, this.transition_not_interested, result.event);
      } else if (outcome == this.uscStoreService.form_not_interested && result.event == "save_to_lasting") {
          this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
      } else if (outcome == this.uscStoreService.form_future_sale) {
        this.showPromptDlg(item, this.transition_new_referral);
      } else {
        this.pageItemsChecked = false;
        this.reloadItems();
      }
    }, (reason) => {
      this.sessionService.log(outcome + ' Closed');
    });
  }

  showEmailComposer(item, curr_event) {
    const modalRef = this.ngbModal.open(UscEmailComposerComponent, { size: "lg", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = this.view;
    modalRef.componentInstance.item = item;
    modalRef.componentInstance.curr_event = curr_event;
    modalRef.result.then((result) => {
      this.pageItemsChecked = false;
      // email composer was launched from impression views, no need to reload
      switch (curr_event) {
        case this.uscStoreService.view_first:
        case this.uscStoreService.view_middle:
        case this.uscStoreService.view_lasting:
          break;
        // email composer was launched after some outcome, must reload
        default:
          this.reloadItems();
          break;
      }
    }, (reason) => {
      console.log("Email Composer Closed");
      this.pageItemsChecked = false;
      // email composer was launched from impression views, no need to reload
      switch (curr_event) {
        case this.uscStoreService.view_first:
        case this.uscStoreService.view_middle:
        case this.uscStoreService.view_lasting:
          break;
        // email composer was launched after some outcome, must reload
        default:
          this.reloadItems();
          break;
      }      
    });    
  }

  showCustomPromptDlg(item, msg_config):NgbModalRef {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.parentView = this.view;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
    modalRef.componentInstance.msg_config = msg_config;
    return modalRef;
  }

  showPromptDlg(item, prompt, curr_event = "") {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.parentView = this.view;
    modalRef.componentInstance.data = item;
    switch (prompt) {
      case this.transition_no_show:
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_no_show;
        break;
      case this.transition_compose_email:
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_compose_email;
        break;
      case this.transition_new_referral:
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_new_referral;
        break;
      case this.transition_optin_request:
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_optin_request;
        break;
      case this.transition_associate_required:
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_associate_required;
        break;
    }

    modalRef.result.then((result) => {
      switch (result.response) {
        case this.uscStoreService.response_record_purchase:
          this.showOutcomeLog(item, this.uscStoreService.form_purchase);
          break;
        case this.uscStoreService.response_move_to_first:
          this.processOutcome(item, this.uscStoreService.action_move_to_first);
          break;
        case this.uscStoreService.response_move_to_lasting:
          this.processOutcome(item, this.uscStoreService.action_move_to_lasting);
          break;
        case this.uscStoreService.response_archive:
          this.processOutcome(item, this.uscStoreService.action_no_show_archive);
          break;
        case this.uscStoreService.response_compose_email:
          this.showEmailComposer(item, curr_event);
          break;
        case this.uscStoreService.response_new_referral:
          this.createNewReferralLead(item);
          break;
        case this.uscStoreService.response_first_to_lasting:
          this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
          break;
        case this.uscStoreService.response_optin_request_en:
        case this.uscStoreService.response_optin_request_fr:
        case this.uscStoreService.response_optin_request_es:
          item.oi_status = 'RI';
          if (item.cfd_esi == "Yes") item.cfd_css = 'Opt-In Requested';
          var pref;
          switch (result.response) {
            case this.uscStoreService.response_optin_request_fr: pref = 'French'; break;
            case this.uscStoreService.response_optin_request_es: pref = 'Spanish'; break;
            default: pref = 'English'; break;
          }
          var params = { "cfd_lp": pref };
          this.uscStoreService.recordSmsIntroAgainstSmsIntroLimit(item, new Date());
          var sub = this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_send_optin_request, params).subscribe(
            result2 => { 
              item.oi_status = 'RI'; 
              if (item.cfd_esi == "Yes") {
                item.cfd_css = 'Opt-In Requested';
                if (this.uscStoreService.isCampaignSpecificSmsIntroLimitEnabled(item.cfd_esil)) this.uscStoreService.incrementDailyCampaignIntroSMSCount(item.cm_ID);
              } 
              if (curr_event == this.event_save_call_back) this.reloadItems();
              this.uscStoreService.setTriggerChatItemReload();
            },
            error => console.log(error)
          );
          break;
      }
    }, (reason) => {
      console.log(prompt + ' Closed');
      switch (prompt) {
        case this.transition_optin_request:
          // No Answer Outcome
          if (curr_event == this.uscStoreService.action_no_answer) {
            this.uscStoreService.recordCallOutComeAgainstCallLimit(item, curr_event, new Date());
            // consultant cancelled sms intro request on lead subtype = '2nd attempt', archive lead
            if (item.dl_sub_type == '2nd Attempt') {
              var params = { idList: `${item.dl_ID}` };
              let dlg = this.showCustomPromptDlg({ }, { msg: 'Max contact attempts reached, archiving lead' });
              this.uscStoreService.processActionOnViewItems(this.view, this.action_mass_archive, params).subscribe(
                result => { 
                  dlg.dismiss();
                  this.reloadItems(); 
                }
              );
            } else {
              this.reloadItems();
            }
          } else if ( curr_event == this.event_save_call_back) {
            this.reloadItems();
          }
          break;
        default:
          if (reason != 'cancel') this.reloadItems();  // default: always reloadItem
          break;
      }
    });
  }

  hasScheduledAppointment(item) { return item.me_date && item.cfd_fumts; }

  getScheduledEventdate(item) {
    return !this.isUSCellRetail ? this.getScheduledDate(item.cfd_fucd, item.cfd_fucts) : this.getScheduledDateFromMeeting(item);
  }
  // rough date conversion 
  getScheduledDate(cfd_date, cfd_timeslot) {
    if (cfd_date && cfd_timeslot) {
      var scheduled_date = new Date( (new Date(cfd_date)).setHours(0, 0, 0));
      var start_time = cfd_timeslot.split('-')[0];
      var hours = parseInt(start_time.substring(0, start_time.indexOf(':')));
      var minutes = parseInt(start_time.substring(start_time.indexOf(':') + 1, start_time.indexOf(':') + 3));
      if (hours != 12) hours += start_time.indexOf("PM") >= 0 ? 12 : 0;
      scheduled_date = addMinutes(scheduled_date, hours * 60 + minutes);
      return scheduled_date;
    }
    return null;
  }

  getScheduledDateFromMeeting(item) {
    var cfd_timeslot = item.cfd_fumts;
    if (cfd_timeslot && item.me_date) {
      var scheduled_date = new Date(item.me_date);
      scheduled_date.setHours(0, 0, 0);
      var start_time = cfd_timeslot.split('-')[0];
      var hours = parseInt(start_time.substring(0, start_time.indexOf(':')));
      var minutes = parseInt(start_time.substring(start_time.indexOf(':') + 1, start_time.indexOf(':') + 3));
      if (hours != 12) hours += start_time.indexOf("PM") >= 0 ? 12 : 0;
      scheduled_date = addMinutes(scheduled_date, hours * 60 + minutes);
      return scheduled_date;
    }
    return null;
  }

  getScheduledCallDateText(item) {
    var scheduled_date = this.getScheduledEventdate(item);
    return scheduled_date ? this.getScheduledDateText(scheduled_date) : "";
  }

  getScheduledMeetingDateText(item) {
    var scheduled_date = this.getScheduledDateFromMeeting(item);
    return scheduled_date ? this.getScheduledDateText(scheduled_date) : "";
  }

  // convert calendar event into text value
  getScheduledDateText(date) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    if (date) {
      var hours = date.getHours();
      var tt = (hours >= 12) ? "PM" : "AM";
      if (hours > 12) hours -= 12;
      var minutes:any = date.getMinutes();
      minutes = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
      var month:any = date.getMonth() + 1;
      month = month < 10 ? "0" + month.toString() : month.toString();
      var date_num:any = date.getDate();
      date_num = date_num < 10 ? "0" + date_num.toString() : date_num.toString();
      return `${days[date.getDay()]} ${date.getFullYear()}-${month}-${date_num} ${hours}:${minutes} ${tt}`;
    }
    return "";
  }
  
  // calendar event scheduled when moving into middle impression
  getEventOverdueClass(item) {
    var scheduled_date = this.getScheduledEventdate(item);
    if (scheduled_date) {
      let now = new Date();
      return (scheduled_date.getTime() < now.getTime()) ? "usc_event_overdue" : "";
    }
    return "";
  }

  // call back date range and store visit date range events
  isEventDateOverdue(item) {
    let date_range = item.cfd_cdr;
    if (this.view == this.uscStoreService.view_middle) {
      date_range = item.cfd_vdr;
    }

    if (date_range) {
      let dates = date_range.split(" to ");
      if (dates.length == 2) {
        let tokens = dates[1].split("-");
        let end_date = new Date(tokens[0], tokens[1] - 1, tokens[2]);
        let now = new Date();
        if (end_date.getFullYear() < now.getFullYear()) {
          return "usc_event_overdue";
        } if (end_date.getMonth() < now.getMonth()) {
          return "usc_event_overdue";
        } else if (end_date.getMonth() == now.getMonth() && end_date.getDate() < now.getDate()) {
          return "usc_event_overdue";
        }
      }
    }
    return "";
  }

  showAttachments(item) {
    const modalRef = this.ngbModal.open(UscAttachmentLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = this.view;
    modalRef.componentInstance.related_type = "contact";
    modalRef.componentInstance.related_ID = item.co_ID;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.mode = "viewer";
    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log('Attachment Closed');
    });
  }

  showDealAttachments(item) {
    const modalRef = this.ngbModal.open(UscAttachmentLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = this.view;
    modalRef.componentInstance.related_type = "deal";
    modalRef.componentInstance.related_ID = item.dl_ID;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.mode = "viewer";
    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log('Attachment Closed');
    });
  }

  editAssociate(item) {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.parentView = this.view;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_edit_associate;

    modalRef.result.then((result) => {
      var params = { dl_account_type: result.associate };
      let dlg = this.showCustomPromptDlg(item, { msg: "Updating Associate" });
      this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_update_associate, params).subscribe(
        result => { 
          dlg.dismiss();
          this.reloadItems(); 
        }
      );
    });
  }

  editChurnResolution(item) {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.parentView = this.view;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_churn_resolution;

    modalRef.result.then((result) => {
      var params = { churn_resolution: result.churn_resolution };
      let dlg = this.showCustomPromptDlg(item, { msg: "Updating Churn Resolution" });
      this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_update_churn_resolution, params).subscribe(
        result => { 
          dlg.dismiss();
          this.reloadItems(); 
        }
      );
    });
  }

  createNewReferralLead(referral_item) {
    const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = this.uscStoreService.form_first_impression;   // default to first impression on new referral
    var referred_by = "Referred By: _FN_ _LN_".replace("_FN_", referral_item.co_firstname).replace("_LN_", referral_item.co_lastname);
    let new_lead = { dl_ID: 0, cfd_nlc: 'Referral', co_work_phone1: null, co_firstname: null, co_lastname: null, dl_account_type: referral_item.dl_account_type, dl_notes: referred_by };
    modalRef.componentInstance.data = new_lead;
    modalRef.result.then((result) => {
      console.log(result);
      let item:any = { };
      result.data.forEach(f => {
        if (f["key"] == "dl_type") {
          item.dl_type = f["value"];
        } else if (f["key"] == "dl_ID") {
          item.dl_ID = f["value"];
          item.view_ID = item.dl_ID;
        }
      });
  
      //this.uscStoreService.reloadCalendarEvents(result.event);
      switch (result.event) {
        case this.uscStoreService.form_response_save_to_first:
        case this.uscStoreService.form_response_save_to_middle:
          this.uscStoreService.setGotoItem(item);
          break;
        case this.uscStoreService.form_response_save_and_new:
          this.createNewReferralLead(referral_item);
          break;
        case this.uscStoreService.form_response_save_purchase:
          this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
        break;
      }
    }, (reason) => {
      console.log("New Referral Closed");
    });
  }

  openChat(item, transition_dlg_type) {
    var store_phone_number = this.uscStoreService.getItemCustomFieldValue(this.activeUser, "Phone Number");
    if (item.co_work_phone1 && item.co_work_phone1.length == 10 && store_phone_number.length == 10) {
      // Agent Only: must have an associate (account_type) to send customer sms 
      if (!this.showAssociate() || item.dl_account_type) {
        if (transition_dlg_type) {
          this.showPromptDlg(item, transition_dlg_type);
        } else {
          this.uscStoreService.setOpenUserChat(item);
        }
      } else {
        this.showPromptDlg(item, this.transition_associate_required);
      }
    } else {
      if (store_phone_number.length < 10) {
        this.openOkDialog("Please work with support to ensure you are setup with a valid store phone number before continuing.", false);
      } else {
        this.openOkDialog("Please ensure the customer have a valid phone number before continuing.", false);
      }
    }
  }

    public openCustomInputDialog(formValues, field) {
        if (field.key == "cfd_fumts2" || field.key == "cfd_fumts") {
            var modal = this.ngbModal.open(UscTimeslotPickerComponent, { size: "lg", backdrop: 'static', keyboard: false });
            modal.componentInstance.schedule_date = new Date(formValues.cfd_fumd);
            modal.componentInstance.view_ID = formValues.dl_ID;
            // if (this.isQueuingModuleAccessEnabled) modal.componentInstance.scheduling_mode = "sn";
            return modal;
        }
        return null;
    }

  // public openQtracTimeslotPicker(formValues, field) {
  //   var modal = this.ngbModal.open(UscTimeslotPickerComponent, { size: "lg", backdrop: 'static', keyboard: false });
  //   modal.componentInstance.schedule_date = new Date(formValues.cfd_fumd);
  //   return modal;
  // }

  hasUnreadMsgs(item): boolean {
    return (item.cfd_hum == "Yes");
  }

  isExistingCustomer(item) { return item.co_type.indexOf('Existing') >= 0; }
  isStatusOptedIn(item) { 
    if (!this.uscStoreService.isCustomerTextMessagingEnabled()) return false;
    return (this.useCampaignOptInStatus(item)) ? item.cfd_css == "Opted-In" : item.oi_status == "OI"; 
  }
  isStatusOptedOut(item) { 
    if (!this.uscStoreService.isCustomerTextMessagingEnabled()) return false;
    return (this.useCampaignOptInStatus(item)) ? item.cfd_css == "Opted-Out" : item.oi_status == "OO"; 
  }
  isStatusOptInRequested(item) { 
    if (!this.uscStoreService.isCustomerTextMessagingEnabled()) return false;
    return (this.useCampaignOptInStatus(item)) ? item.cfd_css == "Opt-In Requested" : item.oi_status == "RI"; 
  }
  // check SMS Enabled > Campaign Opt-In Status > SMS Opt-In Status
  isStatusUnknown(item) {
    if (!this.uscStoreService.isCustomerTextMessagingEnabled()) return false;
    if (this.useCampaignOptInStatus(item)) {
      return item.cfd_css != "Opted-In" && item.cfd_css != "Opted-Out" && item.cfd_css != "Opt-In Requested";
    }
    return item.oi_status != "OI" && item.oi_status != "OO" && item.oi_status != "RI";
  }

  useCampaignOptInStatus(item) { return (item.cfd_css == "Opted-In") || (this.isExistingCustomer(item) && item.oi_status != "OO" && item.cfd_esi == "Yes"); }

  showCampaignMonth(item):boolean {
    switch (item.cm_name) {
      case 'Associate': 
      case 'Email Leads': 
      case 'Web Fallout': 
      case 'Incoming Call': 
      case 'Walk-In': 
      case 'Referral':
      case 'GRO':
      case 'Sponsorship':
        return true;
    }
    return false;
  }

  isCustomerTextMessagingEnabled() : boolean { return this.uscStoreService.isCustomerTextMessagingEnabled(); }

  isCustomerSentimentTrackingEnabled(item) {
    return item.cfd_csc == 'Yes' && item.dl_type == "First Impression"; 
  }

  isHidePhoneNumber(item) {
    return item.cfd_hpn == 'Yes';
  }

  isHideCallBack(item) {
    return item.cfd_hcb == 'Yes';
  }

  isHideNoAnswer(item) {
    return item.cfd_hna == 'Yes';
  }

  isStatusAttempts(item) {
    return item.dl_sub_type.indexOf('Attempt') >= 0 && item.dl_sub_type != '1st Attempt' && item.dl_sub_type != 'Final Attempt';
  }

  isStatusFinalAttempt(item) {
    return item.dl_sub_type === 'Final Attempt';
  }

  isStatusCallBack(item) {
    return item.dl_sub_type === 'Call Back';
  }

  isStatusNoShow(item) {
    return item.dl_sub_type === 'No Show';
  }

  isStatusSmsOnly(item) {
    return item.dl_sub_type === 'SMS Only';
  }

  isStatusReferral(item) {
    return this.showReferralIcon(item);
  }

  showReferralIcon(item) {
    if (item.cm_name == "Referral" && item.dl_sub_type == "1st Attempt") {
      return true;
    } 
    return false;
  }

  isCallType(item, type) {
    return item.cfd_ct == type;
  }

  getProductInterest(item) {
    return this.getInterest(item.cfd_pdi);
  }

  getManufacturerInterest(item) {
    return this.getInterest(item.cfd_mfi);
  }

  getInterest(interest:string) {
    return interest ? interest.split(";").join('<br/>') : "";
  }

  showAssociate() : boolean {
    if (this.isUSCellAgent) {
      switch (this.activeUser.title) {
        case "Agent Development Mgr":
        case "Associate":
        case "Manager":
        case "Area Manager":
        case "Admin/Manager of Agency":
        case "Master":
          return false;
        default:
          return true;
      }
    }
    return false;
    // return this.isUSCellAgent && (title.indexOf('Store') >= 0 || title.indexOf('Admin/Manager of Agency') >= 0 || title.indexOf('Master') >= 0);
  }

  showOutcomes() : boolean {
    if (this.isUSCellAgent) {
      var title = this.activeUser.title;
      return (title.indexOf('Admin/Manager of Agency') < 0 && title.indexOf('Master') < 0);
    }
    return true;
  }

  isOutcomeAllowed() : boolean {
    // disallow outcome actions for hierarchy leaders
    return this.activeUser.username.indexOf('Hierarchy') < 0;
  }

  toggleAdvancedFilter() {
    this.is_advanced_filter_shown = !this.is_advanced_filter_shown;
    this.loadFilter('sql_line_count');
    this.loadFilter('sql_in_contract');
    this.loadFilter('sql_out_of_contract');
    this.loadFilter('sql_handset_count');
    this.loadFilter('sql_iot_count');
    this.loadFilter('sql_cd_count');

    if (this.slider_filters_ready) {
      if (this.line_count_slider) this.line_count_slider.initialize();
      if (this.in_contract_slider) this.in_contract_slider.initialize();
      if (this.out_of_contract_slider) this.out_of_contract_slider.initialize();
      if (this.handset_count_slider) this.handset_count_slider.initialize();
      if (this.iot_count_slider) this.iot_count_slider.initialize();
      if (this.cd_count_slider) this.cd_count_slider.initialize();
    }
  }

  //#region Alerts
  handleAlert(item) {
    if (this.showChurnAlert(item)) this.editChurnResolution(item);
  }

  showChurnAlert(item) { return (item.cfd_possible_churn == "Yes" && !item.cfd_churn_resolution); }
  showChurnResolved(item) { return (item.cfd_possible_churn == "Yes" && item.cfd_churn_resolution); }

  getAlertInfo(item) {
    if (this.showChurnAlert(item)) return "Enter Churn Resolution";
    if (this.showChurnResolved(item)) return "Churn Resolution Recorded";
  }
  //#endregion

  // helper methods - begin
  public openOkDialog(message, bReloadItem) {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
    modalRef.componentInstance.msg_config = { msg: message };
    modalRef.result.then((result) => {
      if (bReloadItem) this.reloadItems();
    }, (reason) => {
      if (bReloadItem) this.reloadItems();
    });
  }
  // helper methods - end
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-impression/usc-impression.component.ts